// @ts-nocheck

export default {
  RECEIPTS_TABLE_STATE_SET: 'RECEIPTS/TABLE_STATE_SET',
  RECEIPTS_TABLE_STATE_RESET: 'RECEIPTS/TABLE_STATE_RESET',
};